<script>
  import Design from "../../Campaign/Design.svelte";
  import { REGULAR } from "../../Campaign/static";
  import { sendTestEmail } from "../static";
  import { ignore } from "../../Common/tools";
  import {External, M} from "../../external";

  export let data;
  export let automationSave;
  export let onSaveEmail = ignore;
  export let onClose = ignore;
  export let onContentChange = ignore;
  export let stepAdd;
  export let stepUpdate;
  export let order;
  export let step;
  export let features = {};

  if (!data) {
    data = {
      content: null
    };
  }

  data.type = REGULAR;

  let instance,
    moreInstance,
    tab = "design";

  export function get() {
    return data;
  }

  export function changeStep(emailContent) {
    step.settings = [];

    step.settings.push({
      key: "subject",
      value: data.subject
    });

    step.settings.push({
      key: "name",
      value: data.name
    });

    step.settings.push({
      key: "email",
      value: data.email
    });

    step.settings.push({
      key: "replyEmail",
      value: data.replyEmail
    });

    step.settings.push({
      key: "emailContent",
      value: JSON.stringify(emailContent)
    });

    step.name = '"' + data.subject + '"';
  }

  async function verify() {
    return await instance.verify();
  }

  async function onSaveBtnClicked() {
    if (!(await verify())) {
      return;
    }
    onSaveEmail();
  }

  async function onSave(onDone) {
    if (!(await verify())) {
      return;
    }
    changeStep(data.content);
    let stepId;
    if (!step.order) step.order = order;
    if (stepAdd) {
      stepId = stepAdd(step);
    }
    if (stepUpdate) {
      stepUpdate(step);
      stepId = step.id;
    }
    automationSave(function () {
      onDone(stepId);
    });
  }

  let next = function () {};

  let changeTab = function (tab) {};

  let moreOptions = function () {
    const target = External.$(moreInstance);
    const items = [
      {
        text: M.SAVE_AS_TEMPLATE,
        icon: "fa-save",
        tag: "save"
      },
      {
        text: M.SELECT_ANOTHER_TEMPLATE,
        icon: "fa-file",
        tag: "template"
      },
      {
        text: M.PREVIEW,
        icon: "fa-eye",
        tag: "preview"
      },
      {
        text: M.SEND_TEST_EMAIL,
        icon: "fa-at",
        tag: "test"
      }
    ];

    External.Tools.showTooltipOptions(target, items, function (target, idx, text, tag) {
      if (tag === "template") {
        External.Tools.prompt(M.DISCARD_DESIGN, M.DISCARD_DESIGN_DESC, function () {
          data.content = null;
        });
        return;
      }

      if (tag === "save") {
        External.Tools.promptForInput(M.TEMPLATE_NAME, M.TEMPLATE_NAME, "", function (value) {
          instance.saveAsTemplate(value);
        });
        return;
      }

      if (tag === "preview") {
        External.Tools.prompt(M.SAVE_AUTOMATION_CHANGES, M.SAVE_AUTOMATION_CHANGES_DESC, async function () {
          await onSave(function (newStepId) {
            let url = "https://" + External.userDomain + "/me/email?id=" + data.automation.id + "&stepId=" + newStepId + " &preview=1";

            External.Tools.showWebsitePreviewPopup({
              url: url,
              buttonText: M.SHOW_IN_NEW_TAB,
              onButtonAction: function (pageUrl) {
                let win = window.open(pageUrl, "_blank");
                win.focus();
              }
            });
          });
        });
        return;
      }

      if (tag === "test") {
        sendTestEmail(data.content, "");
      }
    });
  };
</script>

<div class="email-builder-lane flex flex-row align-center flex-none" style="padding: 5px 40px;">
  <div class="flex align-center flex-1">
    <a class="light-gray-button middle-button circle-effect mr-5" on:click={onClose}>← {M.PREVIOUS}</a>
  </div>
  <div class="flex align-center flex-1 justify-flex-end">
    {#if tab === "design" && data.content !== null}
      <a class="floating-button middle-button blue circle-effect button-with-icon mr-5" on:click={moreOptions} bind:this={moreInstance}
        ><span class="material-icons"> more_vert </span>{M.MORE}</a>
    {/if}
    <a class="middle-button light-gray-button circle-effect mr-5" on:click={onSaveBtnClicked}>
      <span class="material-icons-outlined">save</span>{M.SAVE}
    </a>
  </div>
</div>
<Design bind:data changeTab={changeTab} bind:this={instance} onChange={onContentChange} features={features} />

<style>
  .more-options-btn {
    margin-right: 15px;
  }
</style>
